import { render, staticRenderFns } from "./BuildSources.vue?vue&type=template&id=23e33fb0&"
import script from "./BuildSources.vue?vue&type=script&lang=js&"
export * from "./BuildSources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports